// extracted by mini-css-extract-plugin
export var bgStyle1 = "support-login-module--bg-style-1--0a549";
export var card = "support-login-module--card--9d45a";
export var container = "support-login-module--container--1d995";
export var icon = "support-login-module--icon--75dba";
export var libericaTable = "support-login-module--liberica-table--3f7a1";
export var loginbtn = "support-login-module--loginbtn--9d3c6";
export var migrateCardWrapper = "support-login-module--migrate-card-wrapper--dc32b";
export var plansTable = "support-login-module--plans-table--2e2fc";
export var productsGrid = "support-login-module--products-grid--79575";
export var promoContent = "support-login-module--promo-content--8ed19";
export var promoNik = "support-login-module--promo-nik--5f8f5";
export var slick_dots = "support-login-module--slick_dots--39fcb";
export var support_login_page = "support-login-module--support_login_page--1eed5";
export var support_plan_card = "support-login-module--support_plan_card--41251";
export var support_plans = "support-login-module--support_plans--04da4";
export var tableWrapper = "support-login-module--table-wrapper--6045a";
export var title = "support-login-module--title--a8da0";